import { AccountSlackLinkRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/slack-agent_/link')({
  component: AccountSlackLinkRoute,
});
